import React from "react";
import "./Header.css";

function Header () {
  return (
    <header>
      <h1 id="gameHeader"><strong>Matching Game</strong></h1>
      <h1 id="timeHeader">Time: </h1>
    </header>
  );
}

export default Header;